import { Environment, Language, Subsidiary } from '@coolblue-development/constants';
import { Device, RequestContextHeader as Header, TrafficSource, } from '@coolblue-development/next-request-context-utils';
import { getHeaders } from './getHeaders.js';
export const getRequestContext = async () => {
    const headers = await getHeaders();
    return {
        [Header.ATTEMPT_ID]: getHeader(headers, Header.ATTEMPT_ID, 'attempt-id-was-not-found'),
        [Header.CLIENT_IP]: getHeader(headers, Header.CLIENT_IP, '0.0.0.0'),
        [Header.CLOUDFRONT_REQUEST_ID]: getHeader(headers, Header.CLOUDFRONT_REQUEST_ID, 'request-id-was-not-found'),
        [Header.COOKIE_PREFERENCES]: getHeader(headers, Header.COOKIE_PREFERENCES),
        [Header.COOLBLUE_APP]: getHeader(headers, Header.COOLBLUE_APP),
        [Header.COOLBLUE_CUSTOMER_ID]: getHeader(headers, Header.COOLBLUE_CUSTOMER_ID),
        [Header.COOLBLUE_ACCOUNT_ID]: getHeader(headers, Header.COOLBLUE_ACCOUNT_ID),
        [Header.COOLBLUE_ACCOUNT_NAME]: getHeader(headers, Header.COOLBLUE_ACCOUNT_NAME),
        [Header.COOLBLUE_AUTH_TOKEN]: getHeader(headers, Header.COOLBLUE_AUTH_TOKEN),
        [Header.COOLBLUE_SESSION_ID]: getHeader(headers, Header.COOLBLUE_SESSION_ID, 'session-id-was-not-found'),
        [Header.CORRELATION_ID]: getHeader(headers, Header.CORRELATION_ID, 'correlation-id-was-not-found'),
        [Header.CSRF_TOKEN]: getHeader(headers, Header.CSRF_TOKEN),
        [Header.DEVICE]: getHeader(headers, Header.DEVICE, Device.UNKNOWN),
        [Header.ENVIRONMENT]: getHeader(headers, Header.ENVIRONMENT, process.env.ENVIRONMENT || Environment.PRODUCTION),
        [Header.IS_COOLBLUE_KNOWN_BOT]: getHeader(headers, Header.IS_COOLBLUE_KNOWN_BOT, 'false'),
        [Header.IS_COOLBLUE_USER]: getHeader(headers, Header.IS_COOLBLUE_USER, 'false'),
        [Header.IS_NEW_SESSION]: getHeader(headers, Header.IS_NEW_SESSION, 'true'),
        [Header.LANGUAGE]: getHeader(headers, Header.LANGUAGE, Language.DUTCH),
        [Header.ROUTE]: getHeader(headers, Header.ROUTE),
        [Header.SPLIT_TESTS]: getHeader(headers, Header.SPLIT_TESTS),
        [Header.SUBSIDIARY]: getHeader(headers, Header.SUBSIDIARY, Subsidiary.NL),
        [Header.TRAFFIC_SOURCE]: getHeader(headers, Header.TRAFFIC_SOURCE, TrafficSource.OTHER),
        [Header.COOLBLUE_TRACKING_ID]: getHeader(headers, Header.COOLBLUE_TRACKING_ID, ''),
    };
};
const getHeader = (headers, name, def) => {
    // @ts-expect-error impossible to get the return type to work here
    return headers[name] || def || '';
};
//# sourceMappingURL=getRequestContext.js.map